import React from 'react'
import CustomInputTextComponent from 'components/Form/CustomInputTextComponent';
import {Field} from "formik";
import Select from "components/Form/Select";

const PaymentForm = ({ terminalsOptions }) => {
    return (
    <div style={{width:'100%'}}>
         <Field
                    component={Select}
                    name="terminalId"
                    customlabel="Terminal Servipay"
                    placeholder='Sélectionner un terminal'
                    options={terminalsOptions}
                    required
                />
        <Field type="number" name="amount" customlabel="Montant du paiement" component={CustomInputTextComponent} required/>
        <Field type="text" name="communication" customlabel="Communication" component={CustomInputTextComponent} required/>
    </div>


)}

export default PaymentForm